import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function heading(theme: Theme): ComponentStyle {
  return {
    componentName: 'heading',
    baseStyle: {
      fontWeight: 600,
      color: theme.colors.primary
    }
  };
}
